"use client"

import { ReactNode } from 'react'
import { SimplePetProvider } from '@/context/SimplePetContext'

interface PetContextWrapperProps {
  children: ReactNode
}

export default function PetContextWrapper({ children }: PetContextWrapperProps) {
  // Always render with SimplePetProvider to ensure context is available
  // The SimplePetProvider is safe for SSR and doesn't use URL parameters
  return <SimplePetProvider>{children}</SimplePetProvider>
} 